var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtmistLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 183,
    viewBox: "0 0 207 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 183,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.5 12.8) scale(0.86)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 31.2206,
    y1: 34.1281,
    x2: 51.2206,
    y2: 62.1281,
    stroke: "url(#paint0_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5357,
    y1: 52.5989,
    x2: 47.5357,
    y2: 65.5989,
    stroke: "url(#paint1_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.7339,
    y1: 69.6918,
    x2: 102.734,
    y2: 92.6918,
    stroke: "url(#paint2_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4727,
    y1: 58.715,
    x2: 104.473,
    y2: 89.715,
    stroke: "url(#paint3_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.3205,
    y1: 57.4653,
    x2: 62.3205,
    y2: 64.4653,
    stroke: "url(#paint4_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.636,
    y1: 62.4552,
    x2: 101.636,
    y2: 56.4552,
    stroke: "url(#paint5_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.213,
    y1: 67.8823,
    x2: 112.213,
    y2: 89.8823,
    stroke: "url(#paint6_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.797,
    y1: 139.896,
    x2: 114.797,
    y2: 96.8955,
    stroke: "url(#paint7_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 168L111.563 100.429",
    stroke: "url(#paint8_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.4994,
    y1: 14.9572,
    x2: 96.4994,
    y2: 49.9572,
    stroke: "url(#paint9_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.2481,
    y1: 12.1679,
    x2: 128.248,
    y2: 57.1679,
    stroke: "url(#paint10_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.5529,
    y1: 12.6056,
    x2: 156.553,
    y2: 35.6056,
    stroke: "url(#paint11_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.967,
    y1: 61.9125,
    x2: 157.967,
    y2: 42.9125,
    stroke: "url(#paint12_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 39.5,
    x2: 188,
    y2: 39.5,
    stroke: "url(#paint13_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.474,
    y1: 46.7236,
    x2: 172.474,
    y2: 94.7236,
    stroke: "url(#paint14_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.044,
    y1: 67.9226,
    x2: 168.044,
    y2: 98.9226,
    stroke: "url(#paint15_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.462,
    y1: 69.6658,
    x2: 147.462,
    y2: 139.666,
    stroke: "url(#paint16_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 40L176.454 94.37",
    stroke: "url(#paint17_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9553,
    y1: 102.924,
    x2: 49.9553,
    y2: 69.9236,
    stroke: "url(#paint18_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.788,
    y1: 61.1162,
    x2: 90.788,
    y2: 13.1162,
    stroke: "url(#paint19_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 112C64 160 114.5 117 132 169",
    stroke: "url(#paint20_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 56.9773C-1 84 7.49951 100.977 7.49951 100.977",
    stroke: "url(#paint21_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 23.5C32 23.5 53.3192 12.1601 88.0385 8.64865",
    stroke: "url(#paint22_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.374,
    y1: 104.601,
    x2: 156.374,
    y2: 136.601,
    stroke: "url(#paint23_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.921,
    y1: 102.816,
    x2: 188.921,
    y2: 109.816,
    stroke: "url(#paint24_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 120.5C189 120.5 178.5 132.5 160.291 140.407",
    stroke: "url(#paint25_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 41C199.747 47.4955 213.965 71.4416 197.001 110.029",
    stroke: "url(#paint26_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0136 32.1057C15.5 37.5 11 45 11 45",
    stroke: "url(#paint27_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 7.99998C166.658 7.3937 187.002 30.0004 187.002 30.0004",
    stroke: "url(#paint28_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 51,
    r: 6.5,
    stroke: "url(#paint29_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 28,
    r: 6.5,
    stroke: "url(#paint30_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 67,
    r: 6.5,
    stroke: "url(#paint31_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 8,
    r: 6.5,
    stroke: "url(#paint32_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 35,
    r: 6.5,
    stroke: "url(#paint33_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 115,
    r: 6.5,
    stroke: "url(#paint34_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 63,
    r: 6.5,
    stroke: "url(#paint35_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 143,
    r: 6.5,
    stroke: "url(#paint36_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 175,
    r: 6.5,
    stroke: "url(#paint37_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 94,
    r: 6.5,
    stroke: "url(#paint38_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 107,
    r: 6.5,
    stroke: "url(#paint39_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 55,
    r: 6.5,
    fill: "url(#paint40_linear_84_868)",
    stroke: "url(#paint41_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 39,
    r: 6.5,
    fill: "url(#paint42_linear_84_868)",
    stroke: "url(#paint43_linear_84_868)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 99,
    r: 6.5,
    fill: "url(#paint44_linear_84_868)",
    stroke: "url(#paint45_linear_84_868)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_868",
    x1: 40,
    y1: 49,
    x2: 39.1863,
    y2: 49.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_868",
    x1: 30,
    y1: 60.5,
    x2: 29.6429,
    y2: 61.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_868",
    x1: 81.5,
    y1: 82.5,
    x2: 81.0107,
    y2: 83.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_84_868",
    x1: 100,
    y1: 74.5,
    x2: 99.0182,
    y2: 74.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_84_868",
    x1: 78,
    y1: 59.5,
    x2: 77.7863,
    y2: 58.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_84_868",
    x1: 114,
    y1: 58,
    x2: 114.243,
    y2: 57.0299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_84_868",
    x1: 119,
    y1: 78,
    x2: 118.191,
    y2: 77.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_84_868",
    x1: 132,
    y1: 117.5,
    x2: 132.802,
    y2: 116.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_84_868",
    x1: 121.424,
    y1: 134.246,
    x2: 121.638,
    y2: 134.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_84_868",
    x1: 94.5,
    y1: 32.5,
    x2: 93.5004,
    y2: 32.5286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_84_868",
    x1: 112,
    y1: 35.5,
    x2: 111.168,
    y2: 36.0547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_84_868",
    x1: 127,
    y1: 25.5,
    x2: 126.631,
    y2: 26.4296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_84_868",
    x1: 149,
    y1: 53.5,
    x2: 149.689,
    y2: 54.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_84_868",
    x1: 179,
    y1: 41,
    x2: 179,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_84_868",
    x1: 166.5,
    y1: 71,
    x2: 165.517,
    y2: 71.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_84_868",
    x1: 151,
    y1: 84.5,
    x2: 150.304,
    y2: 85.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_84_868",
    x1: 138,
    y1: 105,
    x2: 137.025,
    y2: 105.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_84_868",
    x1: 183.574,
    y1: 67.2097,
    x2: 183.38,
    y2: 67.1603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_84_868",
    x1: 34,
    y1: 87.5,
    x2: 34.6965,
    y2: 88.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_84_868",
    x1: 74.5,
    y1: 38,
    x2: 75.308,
    y2: 38.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_84_868",
    x1: 78.1857,
    y1: 129.032,
    x2: 71.4207,
    y2: 143.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_84_868",
    x1: 6.49951,
    y1: 78.9773,
    x2: 3.07201,
    y2: 79.1331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_84_868",
    x1: 59.407,
    y1: 13.7127,
    x2: 60.0585,
    y2: 16.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_84_868",
    x1: 162,
    y1: 120,
    x2: 161.084,
    y2: 119.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_84_868",
    x1: 183.5,
    y1: 107.5,
    x2: 182.886,
    y2: 108.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_84_868",
    x1: 175.654,
    y1: 131.866,
    x2: 174.503,
    y2: 130.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_84_868",
    x1: 205.142,
    y1: 75.2495,
    x2: 196,
    y2: 75.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_84_868",
    x1: 17.2038,
    y1: 39.3132,
    x2: 15.7768,
    y2: 37.7565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_84_868",
    x1: 146.37,
    y1: 11.7768,
    x2: 144.501,
    y2: 19.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_84_868",
    x1: 8,
    y1: 43,
    x2: 8,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_84_868",
    x1: 27,
    y1: 20,
    x2: 27,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_84_868",
    x1: 55,
    y1: 59,
    x2: 55,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_84_868",
    x1: 95,
    y1: 0,
    x2: 95,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_84_868",
    x1: 192,
    y1: 27,
    x2: 192,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_84_868",
    x1: 194,
    y1: 107,
    x2: 194,
    y2: 123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_84_868",
    x1: 132,
    y1: 55,
    x2: 132,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_84_868",
    x1: 153,
    y1: 135,
    x2: 153,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_84_868",
    x1: 132,
    y1: 167,
    x2: 132,
    y2: 183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_84_868",
    x1: 109,
    y1: 86,
    x2: 109,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_84_868",
    x1: 11,
    y1: 99,
    x2: 11,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_84_868",
    x1: 97,
    y1: 47,
    x2: 97,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_84_868",
    x1: 97,
    y1: 47,
    x2: 97,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_84_868",
    x1: 163,
    y1: 31,
    x2: 163,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_84_868",
    x1: 163,
    y1: 31,
    x2: 163,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_84_868",
    x1: 174,
    y1: 91,
    x2: 174,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_84_868",
    x1: 174,
    y1: 91,
    x2: 174,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E19B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#3E76CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtmistLogo);
export default __webpack_public_path__ + "static/media/utmist_logo.1df974177dbcd3707c3023e8e3099236.svg";
export { ForwardRef as ReactComponent };